module.exports = __webpack_public_path__ + "img/image24.57c8d8b6.png";